/**
 * Optibase publishes this value after its synchronous identity script runs.
 * Treat the third-party global as untrusted at runtime and omit malformed IDs.
 * https://docs.optibase.io/how-to-setup-optibase/server-side-conversions#tested-user-id
 */
export const getOptibaseTestedUserId = (): string | undefined => {
  const testedUserId = window.optibaseTestedUserId

  if (typeof testedUserId !== 'string') return undefined

  const normalizedTestedUserId = testedUserId.trim()
  return normalizedTestedUserId || undefined
}
